module.exports = __webpack_public_path__ + "img/logo2.021509aa.png";